export const UA = window.navigator.userAgent.toLowerCase()

export const withFusion = /fusionkit/i.test(UA)
export const isAndroid = /android/i.test(UA)

export const isIOS = /iphone os/i.test(UA)
export const isPassenger = /didi\.passenger/i.test(UA)
export const isEnterprise = /didies/i.test(UA)
export const isMini = /didi\.mini/i.test(UA)
export const isKflower = /kflower\.passenger/i.test(UA)
